import { Timeframe } from '@ankr.com/chains-list';

import { StatsTimeframe } from 'modules/stats/types';
import { selectPrivateStatsLoading } from 'modules/stats/actions/fetchPrivateStats';
import { selectProjectRequestsCount } from 'domains/projects/store';
import { useAppSelector } from 'store/useAppSelector';
import { useProjectStatsParams } from 'modules/projects/components/ProjectStatsProvider';

export interface IUseProjectRequestsCountProps {
  timeframe: Timeframe;
  token: string;
}

export const useProjectRequestsCount = ({
  timeframe,
  token,
}: IUseProjectRequestsCountProps) => {
  const statsParams1h = useProjectStatsParams({
    timeframe: StatsTimeframe.Hour,
  });

  const statsParams1d = useProjectStatsParams({
    timeframe: StatsTimeframe.Day,
  });

  const requestsCountFor1h = useAppSelector(state =>
    selectProjectRequestsCount(state, statsParams1h, token),
  );

  const requestsCountFor1d = useAppSelector(state =>
    selectProjectRequestsCount(state, statsParams1d, token),
  );

  const requestsCountFor1hLoading = useAppSelector(state =>
    selectPrivateStatsLoading(state, statsParams1h),
  );

  const requestsCountFor1dLoading = useAppSelector(state =>
    selectPrivateStatsLoading(state, statsParams1d),
  );

  const [requestsCount, requestsCountLoading] =
    timeframe === Timeframe.Hour
      ? [requestsCountFor1h, requestsCountFor1hLoading]
      : [requestsCountFor1d, requestsCountFor1dLoading];

  return { requestsCount, requestsCountLoading };
};
